import React from 'react';
import { mockData } from '../mock';

const BoldTestimonials = () => {
  return (
    <section className="py-20 bg-dark-gradient relative overflow-hidden">
      {/* Dynamic Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric-blue/50 to-transparent"></div>
        <div className="absolute bottom-1/4 right-0 w-full h-px bg-gradient-to-r from-transparent via-neon-green/50 to-transparent"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="heading-power mb-6 animate-slide-power">
            REAL PEOPLE. REAL <span className="text-neon-green">TRANSFORMATIONS</span>.
          </h2>
          <p className="text-energy max-w-3xl mx-auto animate-slide-power delay-200">
            These aren't just testimonials - they're proof that the impossible becomes inevitable 
            when you have the right AI coach pushing you forward.
          </p>
        </div>

        {/* Bold Transformation Cards */}
        <div className="grid lg:grid-cols-3 gap-8">
          {mockData.transformations.map((transformation, index) => (
            <div 
              key={transformation.id}
              className="group relative animate-slide-power hover-lift"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {/* Card Container */}
              <div className="relative bg-black rounded-3xl overflow-hidden neon-border hover-glow">
                {/* Gradient Background Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-electric-blue/10 via-transparent to-neon-green/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Profile Image with Glow */}
                <div className="relative p-8">
                  <div className="relative w-24 h-24 mx-auto mb-6">
                    <div className="absolute inset-0 bg-gradient-primary rounded-full blur-md opacity-50 group-hover:opacity-100 transition-opacity duration-300 scale-110"></div>
                    <img 
                      src={transformation.image}
                      alt={transformation.name}
                      className="relative w-full h-full object-cover rounded-full border-2 border-white/20 group-hover:border-neon-green/50 transition-all duration-300"
                    />
                  </div>

                  {/* Bold Quote */}
                  <blockquote className="relative mb-6">
                    <div className="text-6xl text-electric-blue/30 absolute -top-4 -left-2">"</div>
                    <p className="heading-bold text-white text-lg leading-tight relative z-10 group-hover:text-neon-green transition-colors duration-300">
                      {transformation.quote}
                    </p>
                    <div className="text-6xl text-electric-blue/30 absolute -bottom-8 -right-2">"</div>
                  </blockquote>

                  {/* User Info */}
                  <div className="text-center">
                    <h4 className="text-energy font-bold text-xl mb-1">{transformation.name}</h4>
                    <p className="text-standard text-gray-400 mb-3">{transformation.role}</p>
                    
                    {/* Result Badge */}
                    <div className="inline-block bg-gradient-primary px-4 py-2 rounded-full">
                      <span className="text-white font-bold text-sm uppercase tracking-wide">
                        {transformation.result}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Subtle Energy Border Animation */}
                <div className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-50 transition-opacity duration-300">
                  <div className="absolute inset-0 border border-neon-green/20 rounded-3xl animate-pulse" style={{animationDuration: '2s'}}></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Power Statistics Section */}
        <div className="mt-20 bg-gradient-to-r from-electric-blue/20 to-neon-green/20 rounded-3xl p-12 neon-border animate-slide-power delay-500">
          <div className="text-center">
            <h3 className="heading-power text-white mb-8">
              THE NUMBERS DON'T LIE
            </h3>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-5xl font-black text-neon-green mb-2">{mockData.stats.consistency}</div>
                <div className="text-energy uppercase tracking-wide">Consistency in Daily Habits</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-black text-electric-blue mb-2">{mockData.stats.focus}</div>
                <div className="text-energy uppercase tracking-wide">Report Better Focus</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-black text-neon-green mb-2">{mockData.stats.breakthroughs}</div>
                <div className="text-energy uppercase tracking-wide">Experience Life-Changing Breakthroughs</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-black text-electric-blue mb-2">{mockData.stats.availability}</div>
                <div className="text-energy uppercase tracking-wide">Coaching, Anytime, Anywhere</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoldTestimonials;